import type { PostMediaItem } from '@ps/api/types';
import { PostMediaTypeEnumItem } from '@ps/api/types';

/** Tally images vs videos in a post's `medias` array. */
export function getPostMediaCounts(
  medias: PostMediaItem[] | undefined | null,
): { imageCount: number; videoCount: number } {
  if (!medias) return { imageCount: 0, videoCount: 0 };
  let imageCount = 0;
  let videoCount = 0;
  for (const media of medias) {
    if (media.type === PostMediaTypeEnumItem.Image) imageCount++;
    else if (
      media.type === PostMediaTypeEnumItem.Video ||
      media.type === PostMediaTypeEnumItem.LiveReplay
    ) {
      videoCount++;
    }
  }
  return { imageCount, videoCount };
}
